import { useStore } from 'modules/stores/store/hooks/use-store'
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query'

export const useDeleteItem = () => {
  const { storeId, redirectToMainPage } = useStoreQuery()
  const { mutate } = useStore(storeId)

  const onDelete = async ({
    deleteCallback,
    itemId,
    shouldRedirectToMainPage,
  }: {
    deleteCallback: () => Promise<void>
    itemId: number
    shouldRedirectToMainPage?: boolean
  }) => {
    await deleteCallback()
    await mutate(
      data =>
        data && {
          ...data,
          items: data.items.filter(item => item.itemId !== itemId),
        },
      false,
    )
    if (shouldRedirectToMainPage) {
      await redirectToMainPage()
    }
  }

  return { onDelete }
}
